// Pure functions, no Angular DI. Single capability-check guard (docs/offline-mode-plan.md
// §5/§10/P5): false hides offline video entirely on that browser/device; every other offline
// feature still ships.
//
// Saved video is a plain file in the Origin Private File System, written by a worker and
// played through URL.createObjectURL — see offline-video-files.ts. So the requirement is OPFS
// plus Worker, not Service Worker or MediaSource, which the previous design depended on.
import { isInstalledPwa } from './offline-display-mode';
import { offlineVideoStorageAvailable } from './offline-video-files';

export function offlineVideoSupported(): boolean {
  return offlineVideoStorageAvailable();
}

// iPhone and iPad, in any browser: every iOS browser is WebKit, Chrome and Edge included.
// iPadOS 13+ reports itself as a Mac, so a touch-capable "Mac" is an iPad.
export function isAppleMobileDevice(): boolean {
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints ?? 0) > 1;
}

// Why saving a VIDEO is refused on iPhone/iPad outside the installed app: WebKit deletes all
// of a site's script-writable storage — IndexedDB, OPFS, caches — after 7 days without a visit
// in a browser tab. Home Screen apps are exempt. A student who saves a large video in a Safari
// tab and travels for a week arrives with nothing, and no message saying why. Refusing up front
// with a clear instruction is better than a silent loss later.
//
// Only SAVING is refused. A video already on the device always plays, wherever it is opened.
export function mustInstallToSaveVideo(): boolean {
  return isAppleMobileDevice() && !isInstalledPwa();
}
